export default __webpack_public_path__ + "fdc557f174a93b6889a78b58b1f6129a.png";